import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  initiateJumioRequest,
  jumioSuccessRequest,
  isJumioServiceAvailable
} from '../../redux/actions/individual-user-flow/individual-user-flow-action';
import styled from 'styled-components';
import { getNewUserFlow } from '../../redux/actions/user-state/user-state-action';
import { activateLoader, disableLoader } from '../../redux/actions/ui-trigger/ui-trigger-action';
import {
  changeScreen,
  changeScreenTimelineForJumio
} from '../../redux/actions/user-flow/user-flow-action';
import { BackButton } from '@Components';
import PropTypes from 'prop-types';
import './style.css';
import {
  ID_VERIFICATION_STARTED,
  KYC_METHOD_SELECTED,
  JUMIO_KYC,
  FLOW_TYPE_ONBOARDING
} from '../../utils/constants/eventsConstants';
import COLORS from '../../common/styles/color-pallete';
import { changeOnBoardingScreen } from '../../redux/actions/onboarding/new-onboarding-action';
import { REVAMPED_SCREENS } from '../user-flow/individual/revampedUserFlow/utils/constants';
import { USER_FLOW_NEXT } from '../../redux/action-contants';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import { logEvent } from '../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../utils/events/eventsConstants';
import { CHEVRON_LEFT_ICON } from '@Images';
import { SG_ODD_SCREEN_NAMES } from '../RFI/singpass-ekyc/ScreenConstants';
import { changeRfiSgKYCScreen } from '@Redux/actions/rfi/rfi-action';
import { submitSgKycRfi } from '../RFI/singpass-ekyc/utils';

const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const IframeContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
`;
export const Spacer = styled.div`
  margin-top: 3vh;
`;
const Title = styled.div`
  align-self: center;
  width: 300px;
  text-align: center;
  font-size: 20px;
  margin-bottom: 20px;
  color: ${COLORS.black};
  font-family: ${FONT_FAMILY.hellix.regular} !important;
  font-weight: bold;
`;
const Content = styled.div`
  align-self: center;
  width: 80%;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  color: ${COLORS.black};
  text-align: center;
  font-size: 14px;
  font-family: ${FONT_FAMILY.hellix.regular} !important;
`;
const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 90%;
`;
const HeaderRightContainer = styled.div`
  display: flex;
  flex: 0.95;
  flex-direction: column;
`;
const HeaderLeftContainer = styled.div`
  display: flex;
  flex: 0.05;
  .navigation-container {
    .back-button {
      cursor: pointer;
    }
  }
`;

class JumioVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iframeURL: null,
      jumioStatus: null,
      myUploadDocsInfoMsg:
        'Upload the photo page of either your Passport or your Malaysian ID Card (MYKAD/MYPR).'
    };
  }
  async componentDidMount() {
    this.props.activateLoader();
    this.initiateJumio();
    if (!this.props.isNewUIEnabled) {
      //These events are not required for new onboarding service.
      logEvent(ID_VERIFICATION_STARTED, FLOW_TYPE_ONBOARDING);
      logEvent(
        KYC_METHOD_SELECTED,
        FLOW_TYPE_ONBOARDING,
        { kycType: JUMIO_KYC },
        LOG_TYPE.CLEVER_TAP
      );
    }
  }
  receiveMessage = async (event) => {
    try {
      if (event && event.data) {
        var data = window.JSON.parse(event.data);
        data && (await this.setState({ jumioStatus: data.payload.value }));
        if (data?.payload?.value === 'success') {
          window.removeEventListener('message', this.receiveMessage, false);
          this.redirectScreen(data.workflowExecutionId, data.accountId);
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn(error);
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('message', this.receiveMessage, false);
  };

  initiateJumio = async () => {
    const isNewOnboardingService = this.props.isNewUIEnabled && this.props.country_code === 'MY';
    const data = {
      isJumioWithRfi: false
    };
    let response = await this.props.initiateJumioRequest(data);
    let url = '';
    if (isNewOnboardingService) {
      if (response?.data?.status === 200 && response.data.data) {
        const responseData = response.data.data?.data?.data;
        url = responseData?.webInitiateUrl;
        const jumioCountryCode = responseData?.countryCode;
        this.setState({
          myUploadDocsInfoMsg:
            jumioCountryCode === 'MYS'
              ? 'Upload a photo copy of your Malaysian ID Card(MYKAD/MYPR)'
              : 'Upload a photo copy of your Passport'
        });
      } else {
        this.props.disableLoader();
        return null;
      }
    } else {
      if (response?.data?.success) {
        url = response?.data?.data?.webInitiateUrl;
      } else {
        this.props.disableLoader();
        return null;
      }
    }
    await this.setState({ iframeURL: url });
    // Added setTimeout as Jumio takes 1-2 seconds for initial iframe load
    setTimeout(() => {
      this.props.disableLoader();
    }, 2000);
    window.addEventListener('message', this.receiveMessage, false);
  };

  redirectScreen = async (transactionReference, accountId) => {
    this.props.activateLoader();
    const { sgKycRfiCurrentScreen, tempRfiFormValues } = this.props;
    const isJumioAvailable = await this.props.isJumioServiceAvailable(this.props.country_code);
    const isNewOnboardingService = this.props.isNewUIEnabled && this.props.country_code === 'MY';
    this.props.disableLoader();

    const { poi_poa_upload_page, jumio_verification } = SG_ODD_SCREEN_NAMES;

    if (isJumioAvailable) {
      let response = await this.props.jumioSuccessRequest(
        null,
        null,
        transactionReference,
        accountId
      );
      if (sgKycRfiCurrentScreen === jumio_verification) {
        if (response?.data?.success) {
          this.props.activateLoader();
          submitSgKycRfi(tempRfiFormValues, this.props.dispatch);
          return;
        } else {
          // If jumio complete fails
          this.props.changeRfiSgKYCScreen(poi_poa_upload_page);
        }
        return;
      }
      if (isNewOnboardingService) {
        if (response?.data?.data?.success) {
          this.props.changeOnBoardingScreen(REVAMPED_SCREENS.holdingVerifyScreen);
        }
      } else if (response?.data?.success) {
        let response = await this.props.getNewUserFlow(this.props.account_type);
        if (response && response.data && response.data.success) {
          this.props.changeScreenTimelineForJumio(
            {
              ...response.data.data,
              country_code: this.props.country_code,
              oldTimeLine: this.props.timeline
            },
            true
          );
        }
      }
    } else {
      if (sgKycRfiCurrentScreen === jumio_verification) {
        // if jumio unavailable - redirect user to manual upload screen.
        this.props.changeRfiSgKYCScreen(poi_poa_upload_page);
        return;
      }
      if (isNewOnboardingService) {
        this.props.changeOnBoardingScreen(REVAMPED_SCREENS.ekycServiceDown);
      } else {
        this.props.changeScreen(
          USER_FLOW_NEXT,
          this.props.currentScreen,
          this.props.screens,
          this.props.timeline
        );
      }
    }

    this.props.disableLoader();
  };

  handleNavigateBack = () => {
    this.props.changeOnBoardingScreen(REVAMPED_SCREENS.jumioInitiate);
  };

  render() {
    const { jumioStatus } = this.state;
    const { country_code, isNewUIEnabled, sgKycRfiCurrentScreen } = this.props;
    const isNewOnboardingService = isNewUIEnabled && country_code === 'MY';
    const { jumio_verification } = SG_ODD_SCREEN_NAMES;
    return (
      <Container>
        <HeaderContainer>
          <HeaderLeftContainer>
            {isNewOnboardingService ? (
              <div className="navigation-container">
                <img
                  onClick={this.handleNavigateBack}
                  className="back-button"
                  src={CHEVRON_LEFT_ICON}
                  alt="back"
                />
              </div>
            ) : sgKycRfiCurrentScreen === jumio_verification ? null : (
              <BackButton />
            )}
          </HeaderLeftContainer>
          <HeaderRightContainer>
            <Spacer />
            <Title id="txt_title">Upload your ID document</Title>
            <Content id="txt_content_top">
              {country_code === 'SG' && `Upload the photo page of identity card (NRIC/FIN).`}
              {country_code === 'MY' && this.state.myUploadDocsInfoMsg}
              {country_code === 'HK' && `Upload the photo page of identity card (HKID).`}
            </Content>
            <Content id="txt_content_bottom">
              The images must be in JPG or PNG format and must not exceed 5 MB, PDF files are not
              accepted.
            </Content>
          </HeaderRightContainer>
        </HeaderContainer>

        {this.state.iframeURL && jumioStatus !== 'success' && (
          <IframeContainer>
            <iframe
              allow="camera;fullscreen;accelerometer;gyroscope;magnetometer"
              height="700"
              style={{ width: '90%' }}
              title="Jumio Verification Iframe"
              src={this.state?.iframeURL}
            />
          </IframeContainer>
        )}
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  let {
    rootReducer: {
      userSessionReducer: {
        user_session: { account_type, country_code }
      },
      userFlowReducer: { screens, currentScreen, timeline },
      newUserFlowReducer: { new_onboarding_enabled_users: isNewUIEnabled },
      rfiReducer: {
        sgKycFlow: { currentScreen: sgKycRfiCurrentScreen, tempRfiFormValues }
      }
    }
  } = state;

  return {
    screens,
    currentScreen,
    timeline,
    account_type,
    country_code,
    isNewUIEnabled,
    sgKycRfiCurrentScreen,
    tempRfiFormValues
  };
};

const mapDispatchToProps = {
  initiateJumioRequest,
  jumioSuccessRequest,
  activateLoader,
  disableLoader,
  changeScreen,
  getNewUserFlow,
  changeScreenTimelineForJumio,
  changeOnBoardingScreen,
  isJumioServiceAvailable,
  changeRfiSgKYCScreen,
  dispatch: (action) => action // This ensures dispatch is passed as a prop
};

export default connect(mapStateToProps, mapDispatchToProps)(JumioVerification);

JumioVerification.propTypes = {
  activateLoader: PropTypes.any,
  initiateJumioRequest: PropTypes.any,
  disableLoader: PropTypes.any,
  jumioSuccessRequest: PropTypes.any,
  getNewUserFlow: PropTypes.any,
  account_type: PropTypes.any,
  changeScreenTimelineForJumio: PropTypes.any,
  country_code: PropTypes.string,
  timeline: PropTypes.any,
  changeOnBoardingScreen: PropTypes.any,
  isNewUIEnabled: PropTypes.bool,
  isJumioServiceAvailable: PropTypes.func,
  currentScreen: PropTypes.string,
  screens: PropTypes.array,
  changeScreen: PropTypes.func,
  sgKycRfiCurrentScreen: PropTypes.string,
  changeRfiSgKYCScreen: PropTypes.func,
  tempRfiFormValues: PropTypes.object,
  dispatch: PropTypes.func
};
